import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { SubscriptionCategory } from '@modules/subscriptions/interfaces/subscription-category';
import { PosBox } from '@pos/interfaces/pos-box';
import ModulesHelper from '@core/services/modules.helper';

library.add(faSync);

@Component({
  name: 'bpc-pos-box-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class PosBoxTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {};
  @Prop(String) readonly displayConfigName: string;
  @Prop({ type: Array, default: null }) readonly selectConfigName: string[];
  @Prop({ type: String, default: 'default' }) readonly editFormConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: PosBox = null;
  public entityName = 'pos-box';
  public pluralEntityName = 'pos-boxes';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionsEntityName = 'pos_boxes';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  setEntityAttributesAfterSave() {
    const newEntity = {} as PosBox;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  emitRefreshOpenPosSessions(): void {
    this.$store.dispatch('pos/getOpenPosSession');
  }
  emitRefreshTerminals(): void {
    const hasTerminalPaymentsModule = this.$modulesService.hasModuleActivated(
      ModulesHelper.PAYMENT_TERMINALS_MODULE_NAME,
    );

    if (hasTerminalPaymentsModule) {
      this.$store.dispatch('paymentTerminals/getTerminals');
    }
  }

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
